import * as React from "react";
import { SDKResponseError } from "../sdk";
import { useAuth } from "../shared/useAuth";
import { Well, WellHeading } from "./lib/Well";
import styles from "./ErrorMessage.module.css";

export function ErrorMessage(props: { error: any }) {
  const { signOut } = useAuth();
  const { error } = props;
  if (error?.status === 401) {
    signOut();
    return null;
  }
  const fallbackMessage = "Something went wrong.";
  const message =
    error instanceof SDKResponseError
      ? error?.error?.status === 500
        ? fallbackMessage
        : error?.error?.message ?? fallbackMessage
      : error?.message ?? fallbackMessage;
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <Well>
          <WellHeading>{message}</WellHeading>
        </Well>
      </div>
    </div>
  );
}
